/**
 * Created by nijin on 13/7/17.
 */
import {Component, OnInit, NgZone} from '@angular/core';
import {Http} from "@angular/http";
import {environment} from "../../environments/environment";
import {Router} from "@angular/router";

@Component({
    selector: 'nuc-site-not-available',
    templateUrl: 'site-not-available.component.html',
    styles: [`
    	.siteNotAvailable{
    		text-align: center;
    		margin: auto;
    		width: 443px;
    		position: absolute;
    		left: 50%;
    		top: 50%;
    		transform: translate(-50%, -80%);
    	}
        .siteNotAvailable img{
            width: 180px;
        }
    	.siteNotAvailable p{
            font-size: 20px;
    		margin-top: 20px;
    		color: #456e93;
            font-weight: 600;
    	}
        .siteNotAvailable .btn{
            border: 0;
            font-size: 13px;
            padding: 5px 10px;
            min-width: 87px;
        }
    `]
})
export class SiteNotAvailableComponent implements OnInit {
    constructor( private zone: NgZone) { }
    ngOnInit() {

    }

  reloadPage() { // click handler or similar
    this.zone.runOutsideAngular(() => {
      location.reload();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/site/site-not-available.component.ts